angular.module("bm.reporting.components.templates", ["src/reporting/edit/report-edit-options.html", "src/reporting/generate/report-generate-component.html", "src/reporting/generate/report-generate-modal.html", "src/reporting/list/report-list.html"]);

angular.module("src/reporting/edit/report-edit-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("src/reporting/edit/report-edit-options.html",
    "<form id=\"reportOptionsForm\" name=\"reportOptionsForm\">\n" +
    "    <bmp-page-header ng-class=\"{loading: vm.detailContext.detail.isLoadingData()}\">\n" +
    "        <bmp-page-header-left-content>\n" +
    "            <h1 uib-tooltip=\"{{vm.reportController.reportName}}\" tooltip-trigger=\"mouseenter\"\n" +
    "                tooltip-placement=\"bottom\" class=\"bmp-page-header-truncate\">{{vm.reportController.reportName}}</h1>\n" +
    "        </bmp-page-header-left-content>\n" +
    "        <bmp-page-header-right-content>\n" +
    "            <button type=\"button\" id=\"reportOptionsForm.create\" data-qe-id=\"bm-report-edit-options-create-button\" data-ng-disabled=\"vm.detail.isLoadingData()\" class=\"btn btn-primary\" data-ng-click=\"vm.saveAndGenerate();\"\n" +
    "                translate=\"Bluemoon.Reporting.Actions.Create\"></button>\n" +
    "            <button type=\"button\" id=\"reportOptionsForm.save\" data-ng-disabled=\"vm.detail.isLoadingData()\" class=\"btn btn-default\" data-ng-click=\"vm.saveAndClose();\"\n" +
    "                translate=\"Bluemoon.Reporting.Actions.Save\"></button>\n" +
    "            <button type=\"button\" id=\"reportOptionsForm.cancel\" class=\"btn btn-default\" data-ng-click=\"vm.detail.cancel();\" translate=\"Bluemoon.Reporting.Actions.Cancel\"></button>\n" +
    "        </bmp-page-header-right-content>\n" +
    "    </bmp-page-header>\n" +
    "    <div bento-busy-loader=\"vm.detail.isLoadingData()\">\n" +
    "        <div data-ng-if=\"vm.screenData.dateRangeOptions\">\n" +
    "            <div>\n" +
    "                <label>{{'Bluemoon.Reporting.Actions.ReportDateRange' | translate }}</label>\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-sm-5 col-xs-12 bmp-date-range-selector\">\n" +
    "                        <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"reportDateRangeDropdown\" data-bmp-control-group-label=\"{{'Bluemoon.Reporting.Actions.ReportDateRange' | translate}}\"\n" +
    "                            data-bmp-control-group-label-hide=\"true\">\n" +
    "                            <bmp-enum-combo enum=\"custom\" name=\"reportDateRangeDropdown\" ng-model=\"vm.reportData.dateRange.reportDateRangeId\" custom-items=\"vm.screenData.dateRangeOptions\"\n" +
    "                                value-property=\"id\" on-change=\"vm.onDateOptionChange(item)\" required=\"true\" placeholder=\"{{'Bluemoon.Reporting.Actions.ReportDateRange' | translate}}\">\n" +
    "                            </bmp-enum-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-sm-7 col-xs-12 bmp-date-range-boxes-cols\">\n" +
    "                        <bmp-date-range-boxes name=\"reportDateRange\" ng-model=\"vm.reportData.dateRange\" disabled=\"!vm.selectedDateRange.editable\"\n" +
    "                            date-change=\"vm.onDateChanged()\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div data-ng-if=\"vm.screenData.filterOptions\">\n" +
    "            <div class=\"row\">\n" +
    "                <label class=\"col-md-12\">{{'Bluemoon.Reporting.Actions.Filters' | translate }}</label>\n" +
    "            </div>\n" +
    "            <fieldset>\n" +
    "                <legend class=\"hide-legend-border\" aria-label=\"{{'Bluemoon.Reporting.Actions.Filters' | translate }}\"></legend>\n" +
    "                <div class=\"form-group\">\n" +
    "                    <bmp-filter-tree-component name=\"reportFilter\" ng-model=\"vm.reportData.filter\" fields=\"vm.screenData.filterOptions\" validate=\"reportOptionsForm.$submitted\"></bmp-filter-tree-component>\n" +
    "                </div>\n" +
    "            </fieldset>\n" +
    "        </div>\n" +
    "        <div data-ng-if=\"vm.screenData.detailByItems && vm.reportData.detailBy\">\n" +
    "            <div class=\"row\">\n" +
    "                <label class=\"col-md-12\">{{'Bluemoon.Reporting.Actions.SortBy' | translate }}</label>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-10 col-sm-12 col-xs-12\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <bmp-group-sort-item name=\"sortby\" item=\"vm.reportData.detailBy\" options=\"vm.screenData.detailByItems\" bindings=\"vm.groupingBindings\"\n" +
    "                                />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div data-ng-if=\"vm.screenData.groupByItemsRequired && vm.reportData.groupByRequired && vm.screenData.groupByItemsRequiredOnTop\">\n" +
    "            <div class=\"row\">\n" +
    "                <label class=\"col-md-12\">{{'Bluemoon.Reporting.Actions.GroupBy' | translate }}</label>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-10 col-sm-12 col-xs-12\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <bmp-group-sort-item name=\"groupbyrequired_1\" item=\"vm.reportData.groupByRequired\" options=\"vm.screenData.groupByItemsRequired\" bindings=\"vm.groupingBindings\"/>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div data-ng-if=\"vm.screenData.groupByItems\">\n" +
    "            <div class=\"row\" data-ng-if=\"!vm.screenData.groupByItemsRequiredOnTop\">\n" +
    "                <label class=\"col-md-12\">{{'Bluemoon.Reporting.Actions.GroupBy' | translate }}</label>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-10 col-sm-12 col-xs-12\">\n" +
    "                    <bmp-group-sort name=\"groupby\" items=\"vm.reportData.groupBy\" max-items=\"vm.screenData.groupByItemsMaxCount\" options=\"vm.screenData.groupByItems\"\n" +
    "                        bindings=\"vm.groupingBindings\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div data-ng-if=\"vm.screenData.groupByItemsRequired && vm.reportData.groupByRequired  && !vm.screenData.groupByItemsRequiredOnTop\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-10 col-sm-12 col-xs-12\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <bmp-group-sort-item name=\"groupbyrequired_0\" item=\"vm.reportData.groupByRequired\" options=\"vm.screenData.groupByItemsRequired\" bindings=\"vm.groupingBindings\"/>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div data-ng-if=\"vm.screenData.groupDetailByItems\">\n" +
    "            <div class=\"row\">\n" +
    "                <label class=\"col-md-12\">{{'Bluemoon.Reporting.Actions.GroupDetailBy' | translate }}</label>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-10 col-sm-12 col-xs-12\">\n" +
    "                    <bmp-group-sort name=\"groupdetailby\" items=\"vm.reportData.groupDetailBy\" max-items=\"vm.screenData.groupDetailByItemsMaxCount\" options=\"vm.screenData.groupDetailByItems\"\n" +
    "                    bindings=\"vm.groupingBindings\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-repeat=\"option in vm.screenData.customOptionItems\">\n" +
    "            <div class=\"row\">\n" +
    "                <label class=\"col-md-12\">{{option.name}}</label>\n" +
    "            </div>\n" +
    "            <fieldset>\n" +
    "                <legend class=\"hide-legend-border\" aria-label=\"{{option.name}}\"></legend>\n" +
    "                <div class=\"row\" ng-repeat=\"customOption in option.customOptions\">\n" +
    "                    <div class=\"col-md-5 col-xs-12\">\n" +
    "                        <bmp-additional-custom-options additional-option=\"customOption\" ng-model=\"vm.reportData.customOptionItems[customOption.id]\"\n" +
    "                        />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </fieldset>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("src/reporting/generate/report-generate-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("src/reporting/generate/report-generate-component.html",
    "<ng-form name=\"createReportsForm\">\n" +
    "    <div class=\"row report-generate-component-header report-generate-component-indent\"><h2 id = \"create_dialog_label\">{{ 'Bluemoon.Reporting.Actions.Create' | translate }}</h2></div>\n" +
    "    <hr class=\"report-generate-component\">\n" +
    "    <div class=\"row report-generate-component-header report-generate-component-indent\" id=\"fileType-label\">{{ 'Bluemoon.Reporting.Captions.FileType' | translate }}</div>\n" +
    "    <div class=\"row\" style=\"margin-left:10px;\">\n" +
    "        <div class=\"form-group col-md-6\">\n" +
    "            <bmp-enum-combo\n" +
    "                    ng-if=\"fileTypes\"\n" +
    "                    enum=\"custom\"\n" +
    "                    name=\"fileType\"\n" +
    "                    ng-model=\"data.type\"\n" +
    "                    custom-items=\"fileTypes\"\n" +
    "                    value-property=\"id\"\n" +
    "                    required=\"true\"\n" +
    "                    ng-readonly=\"readOnly\">\n" +
    "            </bmp-enum-combo>\n" +
    "            <bmp-enum-combo\n" +
    "                    ng-if=\"!fileTypes\"\n" +
    "                    enum=\"report-output-types\"\n" +
    "                    name=\"fileType\"\n" +
    "                    ng-model=\"data.type\"\n" +
    "                    value-property=\"id\"\n" +
    "                    required=\"true\"\n" +
    "                    ng-readonly=\"readOnly\">\n" +
    "            </bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Hide this section for future release -->\n" +
    "    <div class=\"row report-generate-component-indent\" ng-hide=\"true\">\n" +
    "        <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"data.bundleMultipleReports\">\n" +
    "            {{'Bluemoon.Reporting.Actions.BundleMultipleReports' | translate }}\n" +
    "        </label>\n" +
    "    </div>\n" +
    "    <div class=\"row report-generate-component-indent\" ng-hide=\"true\">{{'Bluemoon.Reporting.Captions.DocumentName' | translate }}</div>\n" +
    "    <div class=\"row report-generate-component-indent\" ng-hide=\"true\">\n" +
    "        <input type=\"text\" ng-disabled=\"!bundleMultipleReports\" ng-model=\"data.documentName\">\n" +
    "    </div>\n" +
    "    <!-- end of hidden section -->\n" +
    "\n" +
    "    <!-- grouped checkboxes -->\n" +
    "     <fieldset>\n" +
    "        <legend class=\"hide-legend-separator row report-generate-component-header report-generate-component-indent\" aria-label=\"{{'Bluemoon.Reporting.Captions.CreateInDestination' | translate }}\">{{'Bluemoon.Reporting.Captions.CreateInDestination' | translate }}</legend>\n" +
    "        <div class=\"row report-generate-component-indent\">\n" +
    "            <label>\n" +
    "                <input type=\"checkbox\" ng-disabled=\"!showDocuments && !showSendToBinder\" ng-model=\"data.createInDestinationDownloadToComputer\" ng-change=\"changeDownloadDestination()\">\n" +
    "                {{'Bluemoon.Reporting.Actions.Download' | translate }}\n" +
    "            </label>\n" +
    "        </div>\n" +
    "        <div class=\"row report-generate-component-indent\" ng-show=\"showDocuments\">\n" +
    "            <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"data.sendToOnvioDocuments\">\n" +
    "                {{'Bluemoon.Reporting.Actions.SendToOnvio' | translate }}\n" +
    "            </label>\n" +
    "        </div>\n" +
    "        <div class=\"row report-generate-component-indent\" ng-if=\"showSendToBinder\">\n" +
    "            <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"data.sendToBinderDocuments\" ng-change=\"changeSendToBinderDestination()\" />\n" +
    "                {{'Bluemoon.Reporting.Actions.SendToBinder' | translate }}\n" +
    "            </label>\n" +
    "        </div>\n" +
    "     </fieldset>\n" +
    "\n" +
    "    <div class=\"row\" style=\"margin-left:25px; margin-bottom:5px\" ng-show=\"definition.useSelectFolder\">\n" +
    "        <input type=\"text\" ng-disabled=\"!data.sendToOnvioDocuments\" style=\"width:300px; color:#bbbbbb\" ng-model=\"selectedFolder.name\" ng-readonly=\"true\">\n" +
    "        <button class=\"btn btn-primary report-generate-component-button\" ng-disabled=\"!data.sendToOnvioDocuments\" style=\"margin-left:5px;\" ng-click=\"changeFolder()\">\n" +
    "            {{'Bluemoon.Reporting.Actions.Change' | translate }}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "    <!-- Hide for future release -->\n" +
    "    <div class=\"row\" style=\"margin-left:17px;\" ng-hide=\"true\">\n" +
    "        <label class=\"report-generate-component-indent\">\n" +
    "            <input type=\"checkbox\" ng-model=\"data.autoOpenInOnvioDocuments\">\n" +
    "            {{'Bluemoon.Reporting.Actions.AutomaticallyOpenInOnvio' | translate }}\n" +
    "        </label>\n" +
    "    </div>\n" +
    "    <!-- end of hidden section -->\n" +
    "\n" +
    "    <hr class=\"report-generate-component\">\n" +
    "    <div class=\"row\">\n" +
    "        <button class=\"btn btn-primary report-generate-component-button\"\n" +
    "                name=\"createButton\"\n" +
    "                type=\"btn btn-primary\"\n" +
    "                translate=\"Bluemoon.Reporting.Actions.Create\"\n" +
    "                ng-click=\"createReports()\">\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default report-generate-component-button\"\n" +
    "                name=\"cancelButton\"\n" +
    "                type=\"btn btn-default\"\n" +
    "                translate=\"Bluemoon.Reporting.Actions.Cancel\"\n" +
    "                ng-click=\"cancelCreateReports()\">\n" +
    "        </button>\n" +
    "    </div>\n" +
    "\n" +
    "</ng-form>\n" +
    "\n" +
    "");
}]);

angular.module("src/reporting/generate/report-generate-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("src/reporting/generate/report-generate-modal.html",
    "<div role=\"dialog\" aria-labelledby=\"create_dialog_label\" aria-modal=\"true\">\n" +
    "    <button type=\"button\" id=\"closeButton\" class=\"close\" aria-label=\"{{'bmt.notifications.closeDialog' | translate }}\" ng-click=\"close()\">\n" +
    "        <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <bmrc-report-generate-component\n" +
    "        on-create=\"createReports();\"\n" +
    "        on-cancel=\"cancelCreateReports();\"\n" +
    "        report-definition=\"model\"/>\n" +
    "</div>\n" +
    "");
}]);

angular.module("src/reporting/list/report-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("src/reporting/list/report-list.html",
    "<bmp-grid bmp-grid-definition=\"vm.definition\" bmp-grid-service=\"vm.repository\">\n" +
    "</bmp-grid>");
}]);
